export const path: any = {
  normalize: function(path: string): string {
    path = path.replace(/\\/g, '/');
    path = path.replace(/\/\//g, '/');
    return path;
  }
};

// Export normalize function directly for convenience
export const normalizePath = path.normalize;

// URL for a file in the game data; the base comes from config.dataPath.
export function dataUrl(file: string): string {
  const base: string = typeof ROSE_DATA_PATH === 'string' ? ROSE_DATA_PATH : '/data/';
  return base.replace(/\/*$/, '/') + normalizePath(file).replace(/^\/+/, '');
}
